import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// extract common logic from MessageBanner and Toast
// role="alert" is added to the container element to ensure that the message is announced by screen readers
// rendering the container first and the message in the next tick ensures that the message is announced in all browsers
import { forwardRef, useLayoutEffect, useRef, useState } from "react";
import { useCombineRefs } from "../../hooks/useCombineRefs";
export const LiveRegionAlert = forwardRef((props, ref) => {
    const { children, isPolite = false, ...otherProps } = props;
    const liveRegionRef = useRef(null);
    const combinedRef = useCombineRefs(ref, liveRegionRef);
    // render the message immediately in test env, otherwise let the browser render live region first, content second
    // may be removed in the future, only needed for some engines that don't support adding a role="alert" element dynamically (e.g. Firefox)
    // see https://github.com/FreedomScientific/VFO-standards-support/issues/287
    const [isLiveRegionRendered, setIsLiveRegionRendered] = useState(process.env.NODE_ENV === "test");
    useLayoutEffect(() => {
        const liveRegionRenderFrame = requestAnimationFrame(() => setIsLiveRegionRendered(true));
        return () => cancelAnimationFrame(liveRegionRenderFrame);
    }, []);
    return (_jsxs(_Fragment, { children: [!isLiveRegionRendered && _jsx("div", { ...otherProps, children: children }), _jsx("div", { ref: combinedRef, role: "alert", "aria-atomic": "true", "aria-live": isPolite ? "polite" : "assertive", ...otherProps, children: isLiveRegionRendered && children })] }));
});
